import httpUtil from "@/utils/httpUtil";
import config from "@/config"

/** 获取底部数据 */
export function indexconfig(params,type) {
    return httpUtil.get(`${config.API_URL}/api/index/config`, params, type)
}
/** 获取首页数据 */
export function indexInfo(params,type) {
    return httpUtil.get(`${config.API_URL}/api/index/index`, params, type)
}

/** 关于我们 */
export function aboutInfo(params,type) {
    return httpUtil.get(`${config.API_URL}/api/index/about`, params, type)
}

/** 文章 */
export function articlelists(params,type) {
    return httpUtil.get(`${config.API_URL}/api/article/lists`, params, type)
}

/** 文章详情 */
export function articleDetail(params,type) {
    return httpUtil.get(`${config.API_URL}/api/article/detail`, params, type)
}

/** 登录 */
export function zhuanqu(params,type) {
    return httpUtil.get(`${config.API_URL}/api/index/zhuanqu`, params, type)
}


/** 登录 */
export function account(params,type) {
    return httpUtil.post(`${config.API_URL}/api/login/account`, params, type)
}

/** 登录 */
export function sjlists(params,type) {
    return httpUtil.post(`${config.API_URL}/api/exam/lists`, params, type)
}

/** 登录 */
export function sjdetail(params,type) {
    return httpUtil.get(`${config.API_URL}/api/exam/detail`, params, type)
}

/** 查询用户拥有的课程列表 */
export function getcourse(params,type) {
    return httpUtil.get(`${config.API_URL}/api/course/lists`, params, type)
}

/** 查询用户拥有的课程详情 */
export function getcoursedetail(params,type) {
    return httpUtil.get(`${config.API_URL}/api/course/detail`, params, type)
}

/** 查询用户拥有的资源列表 */
export function item_lists(params,type) {
    return httpUtil.get(`${config.API_URL}/api/course/item_lists`, params, type)
}
export function item_detail(params,type) {
    return httpUtil.get(`${config.API_URL}/api/course/item_detail`, params, type)
}

/** 查询所有课程 */
export function getcourseAll(params,type) {
    return httpUtil.get(`${config.API_URL}/api/course/detail`, params, type)
}

/** 获取用户信息 */
export function centerInfo(params,type) {
    return httpUtil.get(`${config.API_URL}/api/student/center`, params, type)
}

/** 修改个人信息 */
export function editInfo(params,type) {
    return httpUtil.post(`${config.API_URL}/api/student/edit`, params, type)
}

/** 修改个人信息 */
export function all_lists(params,type) {
    return httpUtil.get(`${config.API_URL}/api/course/all_lists`, params, type)
}

/** 提交考试 */
export function submit_ks(params,type) {
    return httpUtil.post(`${config.API_URL}/api/exam/submit`, params, type)
}

/** 通过学号查询成绩 */
export function find_chengji(params,type) {
    return httpUtil.post(`${config.API_URL}/api/exam/find_chengji`, params, type)
}

/** 通过科目查询课程大纲 */
export function find_course(params,type) {
    return httpUtil.post(`${config.API_URL}/api/exam/find_course`, params, type)
}

/** 通过科目查询课程大纲 */
export function getRecord(params,type) {
    return httpUtil.post(`${config.API_URL}/api/exam/getRecord`, params, type)
}

/** 获取证书 */
export function get_zhengshu(params,type) {
    return httpUtil.post(`${config.API_URL}/api/exam/get_zhengshu`, params, type)
}

/** 获取书籍 */
export function get_book_lists(params,type) {
    return httpUtil.get(`${config.API_URL}/api/book/lists`, params, type)
}

/** 获取书籍 */
// export function get_book_lists(params,type) {
//     return httpUtil.post(`${config.API_URL}/api/book/lists`, params, type)
// }










